import { useEffect } from "react";

export const useEffectDebounce = (callBack:Function, dependency:any, delay:number) => {
  useEffect(() => {
    const debounce = setTimeout(()=> callBack(), delay);
    return () => clearTimeout(debounce);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[...(dependency || []), delay]);
}